<template>
  <!-- 聊天记录 -->
  <div class="chatRecordBox">
    <div class="typeTagsBox">
      <div
        v-for="item in messageTypeList"
        :key="'messageTypeList' + item.name"
        :class="{
          activationMessageTypeTag: activationMessageTypeName === item.name,
        }"
        @click="activationMessageTypeName = item.name"
      >
        {{ item.title }}
      </div>
    </div>

    <div ref="messageListBox" class="messageListBox">
      <div v-for="(item, index) in data" :key="'messageContentBox' + index" class="messageContentBox">
        <div class="messageContentBoxAvatarBox">
          <div>
            <img :src="item.fromUserId === myInfo.code ? myInfo.avatarUrl : otherSideInfo.avatarUrl" />
          </div>
        </div>
        <div class="messageContentInfoBox">
          <div class="messageContentInfoBoxHeaderBox">
            <span
              :title="
                item.fromUserId === myInfo.code
                  ? myInfo.nickname
                    ? `${myInfo.name}（${myInfo.nickname}）`
                    : myInfo.name
                  : otherSideInfo.nickname
                    ? `${otherSideInfo.name}（${otherSideInfo.nickname}）`
                    : otherSideInfo.name
              "
              style="
                display: inline-block;
                width: 260px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              {{
                item.fromUserId === myInfo.code
                  ? myInfo.nickname
                    ? `${myInfo.name}（${myInfo.nickname}）`
                    : myInfo.name
                  : otherSideInfo.nickname
                    ? `${otherSideInfo.name}（${otherSideInfo.nickname}）`
                    : otherSideInfo.name
              }}
            </span>
            <span style="float: right; font-size: 12px">
              {{ item.timeStamp | getTimeString }}
            </span>
          </div>
          <MessageParsing :data="parameterConversion(item.newBodies, item)" :row-data="item" :style-to-me="false" />
        </div>
      </div>

      <!-- 加载图标 -->
      <div class="loadIconBox">
        <span>
          <a-icon v-if="!isGetAllData" type="loading" />
          {{ isGetAllData ? '没有更多数据了。' : '加载数据。 ' }}
        </span>
      </div>
      <!-- 加载图标 -->
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { getChatHistory } from '@/api/pushSend'
import MessageParsing from '~/components/chat/components/MessageParsing.vue'
export default {
  name: 'ChatRecord',
  components: {
    MessageParsing,
  },
  filters: {
    getTimeString(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  props: {
    // 对放用户信息  用户code code 名称 name 头像 avatarUrl
    otherSideInfo: {
      type: Object,
      default() {
        return {
          code: '',
          name: '',
          avatarUrl: '',
          nickname: '',
        }
      },
    },
    // 我的用户信息
    myInfo: {
      type: Object,
      default() {
        return {
          code: '',
          name: '',
          avatarUrl: '',
          nickname: '',
        }
      },
    },
    // 当前模块激活状态
    isActivation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 当前加载页数
      current: 1,
      data: [],
      // 是否正在加载中
      loading: false,
      // 是否已加载全部数据
      isGetAllData: false,
      // 消息类型列表
      messageTypeList: [
        {
          name: 'all',
          title: '全部',
        },
        {
          name: 'txt',
          title: '文字',
        },
        {
          name: 'img',
          title: '图片',
        },
        {
          name: 'audio',
          title: '语音',
        },
        {
          name: 'video',
          title: '视频',
        },
        {
          name: 'file',
          title: '文件',
        },
        {
          name: 'loc',
          title: '地址信息',
        },
        // , {
        //   name: 'product',
        //   title: '产品'
        // }, {
        //   name: 'card',
        //   title: '名片'
        // }
      ],
      // 激活消息类型
      activationMessageTypeName: 'all',
    }
  },
  computed: {
    isShowAlert() {
      return (
        !this.$store.state.userInfo.memberSetMealInfo ||
        !this.$store.state.userInfo.memberSetMealInfo.setMealCode ||
        this.$store.state.userInfo.memberSetMealInfo.setMealCode === 10000 ||
        this.$store.state.userInfo.memberSetMealInfo.setMealCode === 110000
      )
    },
  },
  watch: {
    isActivation: {
      immediate: true,
      handler(val) {
        if (val && this.data.length === 0) {
          this.loadMore()
        }
      },
    },
    activationMessageTypeName() {
      this.data = []
      this.isGetAllData = false
      this.current = 1
      this.loadMore()
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.messageListBox && this.$refs.messageListBox.addEventListener('scroll', this.scrollDs)
    })
  },
  methods: {
    parameterConversion(info, row) {
      console.log('parameterConversion', info, row)
      if (info.type === 'txt') {
        return {
          type: 'TEXT',
          info: {
            msg: info.msg,
          },
        }
      } else if (info.type === 'img') {
        return {
          type: 'IMAGE',
          info: {
            url: info.url,
          },
        }
      } else if (info.type === 'video') {
        return {
          type: 'VIDEO',
          info: {
            url: info.url,
          },
        }
      } else if (info.type === 'audio') {
        return {
          type: 'VOICE',
          info: {
            url: info.url,
          },
        }
      } else if (info.type === 'file') {
        return {
          type: 'FILE',
          info: {
            url: info.url,
            filename: info.filename,
            file_length: info.file_length,
          },
        }
      } else if (info.type === 'loc') {
        return {
          type: 'LOCATION',
          info: {
            lng: info.lng,
            lat: info.lat,
            addr: info.addr,
          },
        }
      } else if (info.type === 'card') {
        return {
          type: 'CARD',
          info: row.ext,
        }
      } else if (info.type === 'product') {
        return {
          type: 'PRODUCT',
          info: row.ext,
        }
      }
    },
    scrollDs() {
      const el = this.$refs.messageListBox

      if (el.scrollHeight - (el.scrollTop + el.clientHeight) < 200) {
        if (!this.loading && !this.isGetAllData) {
          this.loadMore()
        }
      }
    },
    // 前往升级页面
    toUpgrade() {
      this.$store.commit('chat/switchChatModelShow', false)
      this.$router.push('/upgradevip')
    },
    async loadMore() {
      this.loading = true
      const { data } = await getChatHistory({
        size: 10,
        toMemberCode: this.otherSideInfo.code,
        current: this.current,
        contentType: this.activationMessageTypeName === 'all' ? undefined : this.activationMessageTypeName,
      })
      this.current += 1
      if (!data) {
        return
      }
      const newData = data.records.filter((item) => {
        return item.chatType !== 'read_ack'
      })

      this.data = newData.map((item) => {
        // if (item.type === 'product') {
        //   info = {
        //     ...item,
        //     newBodies: JSON.parse(item.ext)[0],
        //     type: 'product'
        //   }
        // } else if (item.type === 'card') {
        //   info = {
        //     ...item,
        //     newBodies: JSON.parse(item.ext)[0],
        //     type: 'card'
        //   }
        // }
        return {
          ...item,
          newBodies: JSON.parse(item.bodies)[0],
        }
      })

      if (data.records.length < 10) {
        this.isGetAllData = true
      }
      this.loading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.chatRecordBox {
  height: 100%;
  width: 100%;

  .typeTagsBox {
    height: 40px;
    width: 100%;
    border-bottom: 1px solid #e9e9e9;
    padding: 0 20px 0 20px;
    display: flex;
    align-items: center;
    font-size: 12px;

    & > div {
      padding: 0 8px 0 8px;
      height: 24px;
      line-height: 24px;
      // margin-right: 8px;
      user-select: none;
      cursor: pointer;
      transition: all 0.3s;
      border-radius: 4px;
    }

    .activationMessageTypeTag {
      background-color: #ff6600;
      color: white;
    }
  }

  .messageListBox {
    padding: 0 20px 0 20px;
    height: 540px;
    overflow-y: auto;

    &::-webkit-scrollbar-button {
      display: none;
    }

    &::-webkit-scrollbar {
      width: 8px;
    }

    /*定义滚动条轨道 内阴影+圆角*/
    &::-webkit-scrollbar-track {
      background-color: #eee;
    }

    /*定义滑块 内阴影+圆角*/
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #ccc;
    }

    .messageContentBox {
      padding: 20px 0 20px 0;
      border-bottom: 1px solid #e9e9e9;
      display: flex;

      .messageContentBoxAvatarBox {
        width: 50px;
        height: 100%;

        & > div {
          width: 40px;
          height: 40px;
          border-radius: 6px;
          background-color: #e1e1e1;
          overflow: hidden;

          & > img {
            width: 100%;
            height: auto;
          }
        }
      }

      .messageContentInfoBox {
        flex: 1;

        .txtMsg {
          color: black;
        }

        .messageContentInfoBoxHeaderBox {
          height: 16px;
          line-height: 16px;
          margin-bottom: 10px;
        }
      }
    }

    .loadIconBox {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
